export default __webpack_public_path__ + "static/1085-2670be4ab2f5cca1d2b9bdad775caa8a.gif";